export const SyncLogsRouteNames = {
  SYNCLOGS: 'synclogs',
};
